import { Reveal } from "@/components/Reveal";

const PASOS = [
  {
    numero: "1",
    titulo: "Cuéntanos qué quieres proteger",
    texto: "Llena el formulario o escríbenos por WhatsApp.",
  },
  {
    numero: "2",
    titulo: "Recibe opciones comparadas",
    texto: "Te enviamos cotizaciones de varias aseguradoras en menos de 24 horas.",
  },
  {
    numero: "3",
    titulo: "Elige con asesoría",
    texto: "Te explicamos cada cobertura para que decidas con claridad.",
  },
  {
    numero: "4",
    titulo: "Quédate tranquilo",
    texto: "Te acompañamos en renovaciones, cambios y cualquier siniestro.",
  },
];

export const ComoFunciona = () => (
  <section data-testid="como-funciona-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mx-auto max-w-2xl text-center">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-[#1BA8E0]">
          Cómo funciona
        </p>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#0C5F8A] sm:text-3xl lg:text-4xl">
          Asegurarte es así de fácil
        </h2>
      </Reveal>

      <div className="relative mt-16">
        <div className="absolute left-8 top-0 h-full w-0.5 bg-gradient-to-b from-[#1BA8E0]/30 via-[#F5B21B]/40 to-[#1BA8E0]/30 lg:left-0 lg:top-8 lg:h-0.5 lg:w-full lg:bg-gradient-to-r" aria-hidden="true" />
        <ol className="grid gap-12 lg:grid-cols-4 lg:gap-6">
          {PASOS.map((paso, i) => (
            <li key={paso.numero} data-testid={`paso-${paso.numero}`} className="relative pl-24 lg:pl-0 lg:pt-24">
              <Reveal delay={i * 0.12}>
                <span className="absolute left-0 top-0 flex h-16 w-16 items-center justify-center rounded-full border-4 border-white bg-[#1BA8E0] font-display text-2xl font-extrabold text-white shadow-[0_12px_26px_-8px_rgba(27,168,224,0.7)] lg:left-0">
                  {paso.numero}
                </span>
                <h3 className="font-display text-lg font-semibold text-[#0C5F8A]">{paso.titulo}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#2E3338]/75">{paso.texto}</p>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
